import React, { useEffect, useState } from "react";
import "../css/donations.scss";
import { get_dontion_list } from "../apis/GetDontionList.js";
import { LIST_URL } from "../constans/ApiEndpointConstants.js";
import Loading1 from "./common/Loading1.js";
import { generateDonationUrl } from "../utils/urlUtils";
import { useNavigate } from "react-router-dom";
import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";

const AllDonations = () => {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 6;
  const navigate = useNavigate();

  const storedAd = LocalStorageUtil.getAd();
  const ad = storedAd || "donation";

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [All_Donations page]:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  }, [ad]);

  useEffect(() => {
    const fetchList = async () => {
      setLoading(true);
      try {
        const resp = await get_dontion_list(page, perPage, "US");
        const data = resp?.data ?? resp ?? [];
        const list = data.projects || (Array.isArray(data) ? data : []);
        setDonations(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Failed to load donations list:", err);
        setDonations([]);
      } finally {
        setLoading(false);
      }
    };
    fetchList();
  }, [page]);

  // keep current page valid when donations change
  useEffect(() => {
    const totalPages = Math.max(
      1,
      Math.ceil((donations?.length || 0) / perPage)
    );
    if (page > totalPages) setPage(totalPages);
  }, [donations, page]);

  const parseAmount = (val) => {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const s = String(val).replace(/[^0-9.-]+/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const computeProgress = (item) => {
    if (!item) return 0;
    const raised = parseAmount(
      item.raised ?? item.raised_amount ?? item.raisedAmount
    );
    const goal = parseAmount(item.goal ?? item.goal_amount ?? item.goalAmount);
    if (goal > 0) return Math.max(0, Math.min(1, raised / goal));
    return 0;
  };

  const resolveImageUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    const base = LIST_URL.endsWith("/") ? LIST_URL.slice(0, -1) : LIST_URL;
    return raw.startsWith("/") ? base + raw : base + "/" + raw;
  };

  if (loading) {
    return (
      <div className="donations">
        <Loading1 />
      </div>
    );
  }

  const totalPages = Math.max(1, Math.ceil((donations?.length || 0) / perPage));
  const startIdx = (page - 1) * perPage;
  const visibleDonations = donations.slice(startIdx, startIdx + perPage);

  return (
    <>
      <Header />
      {loading ? (
        <Loading1 />
      ) : (
        <section className="donations donations--all">
          <div className="donations__inner">
            <div className="donations__header">
              <h2>All fundraisers</h2>
            </div>

            <div
              className="donations__grid donations__grid--all"
              style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
            >
              {donations.length === 0 && (
                <div style={{ padding: 24 }}>No fundraisers found.</div>
              )}
              {visibleDonations.map((d, idx) => (
                <article
                  className="donations__card"
                  key={idx}
                  onClick={() => {
                    const url = generateDonationUrl(d);
                    if (url) navigate(url);
                  }}
                >
                  <div className="card">
                    <div
                      className="card__img-wrap small"
                      style={{ maxHeight: "210px" }}
                    >
                      <img
                        src={resolveImageUrl(d.image?.[0]?.url || d.img || "")}
                        alt=""
                      />
                      <span className="badge">{d.postType}</span>
                    </div>
                    <div className="card__txt-wrap">
                      <h4 className="card__title">{d.title}</h4>
                      <div className="progress-wrap">
                        <div className="progress">
                          <div
                            className="progress__value"
                            style={{ width: `${computeProgress(d) * 100}%` }}
                          />
                        </div>
                        <div className="raised">
                          {d?.currency_name || ""}
                          {d?.raised || ""} raised
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
            {donations.length > perPage && (
              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className="pagination"
                  role="navigation"
                  aria-label="Pagination"
                >
                  <button
                    className="pagination__btn"
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page <= 1}
                    aria-label="Previous page"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M15 18l-6-6 6-6"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  {/* page number buttons (show window of pages) */}
                  {(() => {
                    const pages = [];
                    const maxButtons = 7;
                    let start = Math.max(1, page - Math.floor(maxButtons / 2));
                    let end = start + maxButtons - 1;
                    if (end > totalPages) {
                      end = totalPages;
                      start = Math.max(1, end - maxButtons + 1);
                    }
                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`pagination__btn page-number ${
                            i === page ? "is-active" : ""
                          }`}
                          onClick={() => setPage(i)}
                          aria-current={i === page ? "page" : undefined}
                        >
                          {i}
                        </button>
                      );
                    }
                    return pages;
                  })()}

                  <button
                    className="pagination__btn"
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page >= totalPages}
                    aria-label="Next page"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M9 6l6 6-6 6"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      )}

      <Footer />
    </>
  );
};

export default AllDonations;
